import { render, staticRenderFns } from "./product-item.vue?vue&type=template&id=fab88b6e"
import script from "./product-item.vue?vue&type=script&lang=ts"
export * from "./product-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fab88b6e')) {
      api.createRecord('fab88b6e', component.options)
    } else {
      api.reload('fab88b6e', component.options)
    }
    module.hot.accept("./product-item.vue?vue&type=template&id=fab88b6e", function () {
      api.rerender('fab88b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "carte/product-item.vue"
export default component.exports